import "@google/model-viewer/dist/model-viewer";
const AndroidArViewer = (glb) => {
  return (
    <model-viewer alt="" src={glb.glb} ar shadow-intensity="1" camera-controls touch-action="pan-y"></model-viewer>
  );
}

export default AndroidArViewer;